<template>
	<div class="popup active">
		<div class="notice_popup recmm" :class="isMobile ? (isRegi ? 'mobile2':'mobile'):''" :style="!isMobile && !isRegi ? 'height: 230px;' : ''">
			<div class="close">
				<img src="/images/close.png" alt="닫기" @click="$emit('close', false)"/>
			</div>
			<template v-if="isRegi">
				<div class="titImg">
					추천한 사람
				</div>
				<div class="main-contents">
					<div class="mem_container" style="background-color: #fff;">
						<div class="mem_agree_contents recmm" :class="isMobile ? 'mobile':''">
							<div class="mem_contents_body recmm" :class="isMobile ? 'mobile':''" style="text-align:center; height:fit-content;">
								<InputComp type="cell" v-model="recmmderHpNo" placeholder="추천인 연락처를 입력해주세요 ( - 를 제외한 숫자만)" :width="isMobile ? '50vw' : '330px'"/>
							</div>
						</div>
						<div class="select-btn pup" :class="isMobile ? 'mobile':''">
							<div class="btn" @click="$emit('close', false)">취소</div>
							<div class="btn" @click="btnSubmit()">등록</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="tit">
					추천한 사람
				</div>
				<div>
					<div class="cont" :class="isMobile ? 'mobile' : ''">추천인 등록을 하시겠습니까?</div>
					<div>
						<div class="select-btn pup" :class="isMobile ? 'mobile':''">
							<div class="btn" @click="$emit('close', false)">아니오</div>
							<div class="btn" @click="regiYn()">예</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	 </div>
	 <!-- <div>
		<template v-if="isRegi">
			<div class="titImg">
				<img src="/images/recmmder_title.png" style="margin:0 auto; display: block;"/>
			</div>
			<div class="main-contents">
				<div class="mem_container">
					<div class="mem_agree_contents recmm">
						<div class="mem_contents_body recmm" style="text-align:center; height:fit-content;">
							<InputComp v-model="recmmderHpNo" maxlength="50" placeholder="추천한 사람의 성명을 입력 해 주세요" :inputable="['han']" width="420"/>
						</div>
					</div>
					<div class="select-btn recmm" style="width:490px; height: 70px;">
						<div class="btn" @click="pupClose()" style="margin-left:90px;">취소</div>
						<div class="btn" @click="btnSubmit()">등록</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="popup active"> 
				<div class="notice_popup recmm" style="margin-top:0px; height:200px;">
					<div class="tit"></div>
					<div style="margin-top:30px;">
						<div class="cont">추천인 등록을 하시겠습니까?</div>
						<div>
							<div class="select-btn pup">
								<div class="btn" @click="pupClose()">아니오</div>
								<div class="btn" @click="regiYn()">예</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	 </div> -->
</template>

<script>

export default {
	data(){
		return {			
			recmmderHpNo: '',
			isRegi: false,
			isMobile: false,
		}
	},

	mounted() {
		this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	},

	methods : {
		pupClose() {
			window.close();
		},
		btnSubmit() {
			// if(this.stipReChk.mandYn == 'Y' && !this.stipReChk.agreeYn) {
			// 	alert('\'' + this.stipReChk.stipNm + '\'은(는) 필수약관 입니다.');
			// 	return;
			// }

			this.$emit('close', {recmmderHpNo : this.recmmderHpNo});
			// window.opener.setRecemmer({recmmderHpNo : this.recmmderHpNo});
		},
		regiYn() {
			this.isRegi = true;
			
			// window.resizeTo(500, 286);
			this.$forceUpdate();
		}
	}
}
</script>